import { render } from "./communicationRecords.vue?vue&type=template&id=cd98a998&scoped=true"
import script from "./communicationRecords.vue?vue&type=script&lang=js"
export * from "./communicationRecords.vue?vue&type=script&lang=js"

import "./communicationRecords.vue?vue&type=style&index=0&id=cd98a998&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd98a998"]])

export default __exports__